import { StatusColor } from '@enums/status-color.enum';
import { TaskPlanningInvoicingStatusCode } from '@enums/task-planning-invoicing-status-code.enum';

export const TASK_PLANNING_INVOICING_STATUS_COLOR: Record<TaskPlanningInvoicingStatusCode, StatusColor> = {
  [TaskPlanningInvoicingStatusCode.billable]: StatusColor.grey3,
  [TaskPlanningInvoicingStatusCode.billed]: StatusColor.accent,
  [TaskPlanningInvoicingStatusCode.na]: StatusColor.accent,
  [TaskPlanningInvoicingStatusCode.toBill]: StatusColor.grey3,
  [TaskPlanningInvoicingStatusCode.toBillOnDelivery]: StatusColor.grey3
};
